<template>
    <div>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('name')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('surname')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.surname) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('mobile_number')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.mobile_tel) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('email')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.email) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('national_id')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.national_id) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('campus')">
                    <b-input-group>
                        <div class="label-as-input"> {{ this.getLocaleText(form, 'campus_name') }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('city')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.city_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('district')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.district_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import PromotionalProcessService from '@/services/PromotionalProcessService';

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                form: {
                    name: null,
                    surname: null,
                    mobile_tel: null,
                    email: null,
                    national_id: null,
                    campus_name: null,
                    city_name: null,
                    district_name: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                PromotionalProcessService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            }
        }
    }
</script>
